import React from 'react'

import { RouteObject } from 'react-router-dom'

function withErrorBoundary(
  routes: RouteObject[],
  errorElement: React.ReactNode
): RouteObject[] {
  return routes.map((route) => {
    if ('children' in route && route.children) {
      return {
        ...route,
        errorElement,
        children: withErrorBoundary(route.children, errorElement), // Recursively apply errorElement
      }
    }

    return {
      ...route,
      errorElement,
    }
  })
}

export default withErrorBoundary
